import {
  TvShopEntertainmentPackGroup
} from '../../interfaces/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.interface';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';

export enum TvShopEntertainmentPackGroupIds {
  NETFLIX_STANDALONE = 'netflix-standalone',
  DISNEY_STANDALONE = 'netflix-standalone',
}

export const NetflixStandaloneEntertainmentPackGroup: TvShopEntertainmentPackGroup = {
  omapiId: TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE,
  childPackOmapiIds: OmapiIdsUtils.NETFLIX_STANDALONE_PRODUCTS,
  defaultChildPackOmapiId: OmapiIdsUtils.NETFLIX_BASIC_ID
};

export const TvShopEntertainmentPackGroups: TvShopEntertainmentPackGroup[] = [
  NetflixStandaloneEntertainmentPackGroup
];
